"use strict";

exports.__esModule = true;
exports.useTable = exports.tableContext = exports.TableProvider = void 0;

var _react = require("react");

// deps
const tableContext = /*#__PURE__*/(0, _react.createContext)({
  headers: {},
  layout: null
});
exports.tableContext = tableContext;
tableContext.displayName = "TableContext";
const TableProvider = tableContext.Provider;
exports.TableProvider = TableProvider;

const useTable = function () {
  return (0, _react.useContext)(tableContext);
};

exports.useTable = useTable;